import { Box, useTheme } from '@mui/material';
import clsx from 'clsx';
import React, { FC, PropsWithChildren } from 'react';

import { useConvertToKeyEvent } from '../../hooks/useConvertToKeyEvent';

import { cardClassIdentifier, cardStyles } from './sharedCardStyles';

interface CardProps {
  className?: string;
  onClick?: () => void;
}

/**
 * Renders an empty Card without padding
 */
const Card: FC<PropsWithChildren<CardProps>> = ({ children, className, onClick }) => {
  const theme = useTheme();
  const onKeyDown = useConvertToKeyEvent(onClick);
  const classes = clsx(cardClassIdentifier, className);

  return (
    <Box className={classes} data-testid="card" sx={cardStyles(theme)} onClick={onClick} onKeyDown={onKeyDown}>
      {children}
    </Box>
  );
};

export default Card;
